module.exports = __webpack_public_path__ + "045302247aa00bd1140141af6ffb9f06.pdf";